// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6829) return "static/chunks/6829-b6c1a8c282d6af4b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1":"db917fbfab8da076","1424":"85e43a4998b7fc0a","3908":"00c5504c54e0dc7d","4035":"613095586a258de9","6304":"98f8aeba49fd5c21","8788":"c208db9f286ff9c9","9645":"631b243660357878","9711":"b364098a5c92514e"}[chunkId] + ".js";
};